import { raiseUnreachable, vyDate } from '@vy/utils';
import {
  PRODUCT_USAGE_BREAKDOWN_DATE_RESOLUTIONS,
  ProductUsageBreakdownDateResolution,
} from '../product-usage-breakdown-chart-types/product-usage-breakdown-date-resolution';

export function formatDateByResolution(
  date: Date,
  dateResolution: ProductUsageBreakdownDateResolution,
): string {
  switch (dateResolution) {
    case PRODUCT_USAGE_BREAKDOWN_DATE_RESOLUTIONS.DAY:
      return vyDate(date).format('YYYY-MM-DD');
    case PRODUCT_USAGE_BREAKDOWN_DATE_RESOLUTIONS.WEEK: {
      const weekStart = vyDate(date).startOf('week').format('YYYY-MM-DD');
      const weekEnd = vyDate(date).endOf('week').format('YYYY-MM-DD');

      return `${weekStart} - ${weekEnd}`;
    }
    case PRODUCT_USAGE_BREAKDOWN_DATE_RESOLUTIONS.MONTH:
      return vyDate(date).format('MMM, YY');
    default:
      return raiseUnreachable(dateResolution);
  }
}
